import {
  OPEN_REVIEW_DIALOG,
  CLOSE_REVIEW_DIALOG,
  DELETE_REVIEW,
  CREATE_REVIEW,
  EDIT_REVIEW,
  REVIEW_REQUEST_ERROR,
  LIKE_REVIEW_TOGGLE,
  LIKE_REVIEW_SUCCESS,
  LIKE_REVIEW_FAILED,
  CREATE_REVIEW_SUCCESS,
  EDIT_REVIEW_SUCCESS,
  DELETE_REVIEW_SUCCESS,
  UPDATE_REVIEW_SUMMARY,
  UPDATE_REVIEW_DATA,
  CREATE_SHOP_REVIEW,
  CREATE_SHOP_REVIEW_SUCCESS,
  EDIT_SHOP_REVIEW,
  EDIT_SHOP_REVIEW_SUCCESS,
  DELETE_SHOP_REVIEW,
  DELETE_SHOP_REVIEW_SUCCESS,
  HIDE_SHOP_REVIEW_THANK_YOU,
  SAVE_REVIEW_DRAFT,
} from '../actions';

const DEFAULT_PAGE_INFO = { offset: 0, limit: 15 };

export default (state, action) => {
  if (!state) {
    return {
      pendingRequest: false,
      requestError: null,

      pageInfo: {
        store: DEFAULT_PAGE_INFO,
        product: DEFAULT_PAGE_INFO,
        profile: DEFAULT_PAGE_INFO,
      },

      updatedReviews: null,
      updatedSummary: null,
      drafts: null,

      dialog: {
        openId: null,
      },
      thankYouDialog: {
        openId: null,
      },
    };
  }

  switch (action.type) {
    case CREATE_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'create' },
        requestError: null,
      };

    case EDIT_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'edit' },
        requestError: null,
      };

    case DELETE_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'delete' },
        requestError: null,
      };

    case CREATE_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
      };

    case CREATE_SHOP_REVIEW:
      return {
        ...state,
        pendingRequest: true,
        requestError: null,
      };

    case CREATE_SHOP_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
        thankYouDialog: {
          openId: state.dialog.openId,
        },
        dialog: {
          openId: null,
        },
      };

    case EDIT_SHOP_REVIEW:
      return {
        ...state,
        pendingRequest: true,
        requestError: null,
      };

    case EDIT_SHOP_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
        dialog: {
          openId: null,
        },
      };

    case DELETE_SHOP_REVIEW:
      return {
        ...state,
        pendingRequest: true,
        requestError: null,
      };

    case DELETE_SHOP_REVIEW_SUCCESS: {
      const drafts = state.drafts;
      // Delete drafts for the review and shop when deleting a review
      if (drafts && drafts[action.reviewId]) delete drafts[action.reviewId];
      if (drafts && drafts[action.shopId]) delete drafts[action.shopId];

      return {
        ...state,
        pendingRequest: false,
        dialog: {
          openId: null,
        },
        drafts,
      };
    }

    case HIDE_SHOP_REVIEW_THANK_YOU:
      return {
        ...state,
        thankYouDialog: {
          openId: null,
        },
      };

    case EDIT_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
      };

    case DELETE_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
      };

    case UPDATE_REVIEW_DATA:
      return {
        ...state,
        updatedReviews: {
          shopId: action.shopId,
          productId: action.productId,
          nodes: action.nodes,
          myReview: action.myReview,
        },
      };

    case UPDATE_REVIEW_SUMMARY:
      return {
        ...state,
        updatedSummary: action.summary,
      };

    case OPEN_REVIEW_DIALOG:
      return {
        ...state,
        dialog: {
          openId: action.uid,
        },
        requestError: null,
      };

    case CLOSE_REVIEW_DIALOG:
      return {
        ...state,
        dialog: {
          openId: null,
        },
        requestError: null,
      };

    case REVIEW_REQUEST_ERROR:
      return {
        ...state,
        requestError: action.errorCode,
        pendingRequest: false,
      };

    case LIKE_REVIEW_TOGGLE:
      return {
        ...state,
        pendingRequest: true,
      };

    case LIKE_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
      };

    case LIKE_REVIEW_FAILED:
      return {
        ...state,
        pendingRequest: false,
      };

    case SAVE_REVIEW_DRAFT: {
      const newDrafts = {
        ...state.drafts,
        ...action.draft,
      };
      return {
        ...state,
        drafts: newDrafts,
      };
    }

    case 'SET_SHOP_REVIEW_PAGEINFO': {
      if (!action.pageInfoType) return { ...state };

      return {
        ...state,
        pageInfo: {
          ...state.pageInfo,
          [action.pageInfoType]: action.pageInfo,
        },
      };
    }

    case 'ROUTE_LOADED':
      return {
        ...state,
        updatedReviews: null,
        updatedSummary: null,
        dialog: {
          openId: null,
        },
        thankYouDialog: {
          openId: null,
        },
      };

    default:
  }

  return state;
};
